import { alpha, createTheme } from '@mui/material/styles';


const palettes = {
  light: {
    background: { default: '#f3f0e8', paper: '#fffdf8' },
    text: { primary: '#23312e', secondary: '#5f6f6a' },
    primary: { main: '#176b5b', dark: '#105044', contrastText: '#ffffff' },
    secondary: { main: '#b86f36' },
    divider: '#d9d6cc',
  },
  dark: {
    background: { default: '#22332f', paper: '#2c403a' },
    text: { primary: '#f5f1e7', secondary: '#c4d0ca' },
    primary: { main: '#7ac9b0', dark: '#5aac94', contrastText: '#17332b' },
    secondary: { main: '#e0a169' },
    divider: '#496058',
  },
};

export default function getTheme(mode = 'light') {
  const palette = palettes[mode] || palettes.light;
  return createTheme({
    palette: { mode, ...palette },
    typography: {
      fontFamily: "Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      h1: { fontSize: 'clamp(2.2rem, 5vw, 4.3rem)', lineHeight: 1.05, fontWeight: 800, letterSpacing: '-0.045em' },
      h2: { fontSize: 'clamp(2rem, 4vw, 3.4rem)', lineHeight: 1.08, fontWeight: 800, letterSpacing: '-0.04em' },
      h3: { fontSize: '1.75rem', fontWeight: 750, letterSpacing: '-0.025em' },
      h4: { fontSize: '1.4rem', fontWeight: 750, letterSpacing: '-0.02em' },
      h5: { fontSize: '1.08rem', fontWeight: 750 },
      body1: { lineHeight: 1.65 },
      body2: { lineHeight: 1.55 },
      button: { textTransform: 'none', fontWeight: 700 },
      overline: { fontWeight: 800, letterSpacing: '0.08em' },
    },
    shape: { borderRadius: 16 },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundImage: mode === 'light'
              ? 'radial-gradient(circle at 12% 8%, rgba(23, 107, 91, 0.08), transparent 32%), radial-gradient(circle at 88% 16%, rgba(184, 111, 54, 0.08), transparent 28%)'
              : 'radial-gradient(circle at 12% 8%, rgba(122, 201, 176, 0.10), transparent 32%)',
            backgroundAttachment: 'fixed',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            color: palette.text.primary,
            backgroundColor: alpha(palette.background.default, 0.88),
            backdropFilter: 'blur(14px)',
            borderBottom: `1px solid ${palette.divider}`,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            border: `1px solid ${palette.divider}`,
            boxShadow: mode === 'light'
              ? '0 18px 48px rgba(47, 61, 56, 0.08)'
              : '0 18px 48px rgba(10, 20, 18, 0.18)',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            borderColor: palette.divider,
            boxShadow: 'none',
            transition: 'transform 160ms ease, box-shadow 160ms ease',
            '&:hover': {
              transform: 'translateY(-3px)',
              boxShadow: mode === 'light'
                ? '0 16px 38px rgba(47, 61, 56, 0.10)'
                : '0 16px 38px rgba(10, 20, 18, 0.22)',
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 999, paddingInline: 18 },
          contained: { boxShadow: 'none' },
        },
      },
      MuiChip: {
        styleOverrides: { root: { borderRadius: 999, fontWeight: 650 } },
      },
      MuiTextField: {
        defaultProps: { variant: 'outlined' },
      },
    },
  });
}
